import { useMemo } from 'react';
import styled from 'styled-components';

import { stepsList } from '@components/BookingProcessModal/DisplayStep/steps';

import { IndividualStep } from './IndividualStep';

type ProcessStepperProps = {
  currentStepIndex: number;
};
export const ProcessStepper = ({ currentStepIndex }: ProcessStepperProps) => {
  const completedStepIndexes = useMemo(() => {
    const list =
      currentStepIndex > 0
        ? Array.from({ length: currentStepIndex + 1 }).map((_, index) => index)
        : [0];
    return new Set(list);
  }, [currentStepIndex]);
  return (
    <StyledContainer>
      {stepsList.map(({ title, mobileTitle }, index) => {
        return (
          <IndividualStep
            key={`${title}-${index}`}
            title={title}
            currentIndex={currentStepIndex}
            ownIndex={index}
            completedStepIndexes={completedStepIndexes}
            mobileTitle={mobileTitle}
          />
        );
      })}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 40px;

  @media (max-width: 960px) {
    margin-top: 24px;
    flex-direction: row;
    gap: 0;
  }
`;
